import { Link } from "react-router-dom";

export default function Wordmark({ dark = false, className = "" }) {
  const base = dark ? "text-paper" : "text-ink";
  return (
    <Link to="/" data-testid="brand-logo" className={`group inline-flex flex-col leading-none ${className}`}>
      <span className={`font-display text-xl md:text-[1.4rem] font-bold tracking-tight ${base}`}>
        NOVA<span className="text-gold">LEAN</span>
      </span>
      <span className={`label-mono mt-1 ${dark ? "text-steel" : "text-ink/50"}`}>Consulting</span>
    </Link>
  );
}
